import { render, staticRenderFns } from "./modalSelectAvatarRegistro.vue?vue&type=template&id=27f831ee&"
import script from "./modalSelectAvatarRegistro.vue?vue&type=script&lang=js&"
export * from "./modalSelectAvatarRegistro.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports